import React from "react";
import { Button, type ButtonProps } from "app/_components/components/Button";
import { cn } from "app/_components/components/utils";

interface ChartAlertButtonProps extends ButtonProps {
  isTooltipVisible?: boolean;
  icon?: React.ReactNode;
}

export const ChartAlertButton = React.forwardRef<
  HTMLButtonElement,
  ChartAlertButtonProps
>(({ isTooltipVisible, className, children, icon, ...props }, ref) => {
  return (
    <div className="relative inline-flex">
      <Button
        ref={ref}
        className={cn(
          "relative h-8 w-8 bg-[rgba(255,255,255,0.12)]! p-0 text-white hover:bg-[rgba(255,255,255,0.16)]! [&_svg]:text-white",
          isTooltipVisible && "overflow-visible",
          className
        )}
        {...props}
      >
        {icon && <span className="flex items-center">{icon}</span>}
        {children}
      </Button>
      <div
        className={cn(
          "absolute bottom-[-16px] left-1/2 h-3 w-3 -translate-x-1/2 rotate-45 bg-[#00d4ff] opacity-0 transition-opacity duration-0",
          isTooltipVisible && "opacity-100 delay-500"
        )}
      />
    </div>
  );
});

ChartAlertButton.displayName = "ChartAlertButton";
